export default __webpack_public_path__ + "static/media/toast-dark-tick.496b94ec.svg";